var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-2739.27,-5650.17)"},React.createElement("g",{"transform":"matrix(0.647196,0,0,1,1933.49,5367.59)"},React.createElement("g",{"transform":"matrix(3.09025,0,0,1.75932,1226.49,267.462)"},React.createElement("path",{"d":"M16.59,8.59L12,13.17L7.41,8.59L6,10L12,16L18,10L16.59,8.59Z","style":{"fill":"white","fillRule":"nonzero"}})))));
}

DownArrow.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 14","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = DownArrow;

DownArrow.default = DownArrow;
